import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { DocumentDecorator } from 'decorators'

export class Document extends BaseModel<Document> {
  static DEFAULT_ATTRIBUTES = {}

  kind: string
  number: string
  issuedAt: Moment
  authority: string
  homeAddress: string

  private decorator: DocumentDecorator

  decorate(): DocumentDecorator {
    if(!this.decorator) { this.decorator = new DocumentDecorator(this) }
    return this.decorator
  }

  public filled(): boolean {
    return !(this.kind == null && this.number  == null && this.issuedAt  == null && this.authority  == null && this.homeAddress  == null)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/document.model.ts